window.addEventListener('load', () => {
  const gfActions = document.querySelector(".gf-actions");
  const announcement = document.querySelector(".announcement--section");
  const nav = document.querySelector("nav");
  if (!gfActions) return;

  let pos_trigger = gfActions.getBoundingClientRect().top + window.scrollY + 50;
  let lastScrollTop = window.scrollY; 

  function checkNavPosition() {
    let scrollTop = window.scrollY;
    let isScrollingDown = scrollTop > lastScrollTop;
    let announcementHeight = announcement ? announcement.offsetHeight : 0;
    let navHeight = nav ? nav.offsetHeight : 0;

    if (scrollTop > pos_trigger) {
      gfActions.classList.add("fixed");
      if (isScrollingDown) {
        gfActions.style.top = `${announcementHeight}px`;
      } else {
        gfActions.style.top = `${announcementHeight + navHeight}px`;
      }
    } else {
      gfActions.classList.remove("fixed");
      gfActions.style.top = "";
    }

    lastScrollTop = scrollTop;
  }

  window.addEventListener("scroll", checkNavPosition);

  const targetElement = document.querySelector('html');
  if (targetElement) {
    const observer = new MutationObserver(mutations => {
      mutations.forEach(mutation => {
        if (mutation.attributeName === 'class') {
          setTimeout(function() {
            const hasFilterClass = targetElement.classList.contains('offcanvas-open');
            //console.log('Las clases del <html> han cambiado:', targetElement.className);
            //console.log(hasFilterClass ? 'El <html> tiene la clase .spf-has-filter' : 'El <html> NO tiene la clase .spf-has-filter');
            if(hasFilterClass) {
              const gfActions = document.querySelector(".gf-actions");
              gfActions.style.top = '0px';
            } else {
              const nav = document.querySelector('.navigation');
              const announcement = document.querySelector(".announcement--section");
              let navHeight = nav ? nav.offsetHeight : 0;
              let announcementHeight = announcement ? announcement.offsetHeight : 0;

              if (nav?.classList.contains('active')) {
                gfActions.style.top = `${announcementHeight + navHeight}px`;
              } else {
                gfActions.style.top = `${announcementHeight}px`;
              }
            }
          }, 500);
        }
      });
    });

    observer.observe(targetElement, { attributes: true, attributeFilter: ['class'] });
  }
});
